import { CANVAS_GRID_PX, CANVAS_HEIGHT_PX, CANVAS_WIDTH_PX } from "../../lib/canvas-coordinates";

// 50px ごとの薄い点線グリッド。
// 各点をひとつずつ描画するのではなく、CSS の radial-gradient と background-size を使い
// パフォーマンスを稼ぐ。stage の transform: scale に対しても合成的に変形する。
export function CanvasGrid(): JSX.Element {
  return (
    <div
      aria-hidden
      style={{
        position: "absolute",
        inset: 0,
        width: `${CANVAS_WIDTH_PX}px`,
        height: `${CANVAS_HEIGHT_PX}px`,
        pointerEvents: "none",
        backgroundImage:
          "radial-gradient(circle, var(--color-grid-dot) 1px, transparent 1px)",
        backgroundSize: `${CANVAS_GRID_PX}px ${CANVAS_GRID_PX}px`,
        backgroundPosition: "0 0",
      }}
    />
  );
}
